export function convert(bytes: number):string
{
  return bytes < 800000000 ? (bytes/1000000).toFixed(2) + 'MB' : (bytes/1000000000).toFixed(2) + 'GB';
}